<template>
    <div class="double-bar-page">
        <div class="charts" ref="doubleBar"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: "DoubleBarCharts",
    props: {
        // 是否开启双 Y 轴
        doubleY: {
            type: Boolean,
            default: false
        },
        // 数据列表
        list: {
            type: Array,
            default(){
                return [];
            }
        },
        // 柱状图的颜色
        colors: {
            type: Array,
            default(){
                return ['#0de9e8', '#ee9d8e'];
            }
        },
        // 双柱状图的名称，对应 data 中 firstList 和 secondList 中的数据；格式为 [{name:中文名, type:对应的 list 中的名字}]
        legendData: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            myChart: null,
            // 第一组数据
            firstList: [],
            // 第二组数据
            secondList: [],
            // x 轴的名称
            xName: []
        }
    },
    mounted(){
        this.myChart = echarts.init(this.$refs.doubleBar);
        window.addEventListener("resize", this.handleWindowResize);
    },
    methods: {
        initData(){
            if(this.myChart){
                this.initCharts();
            }
        },
        // 初始化
        initCharts(){
            let option = {
                color: this.colors,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    left: '14%',
                    top: '15%',
                    right: '5%',
                    bottom: '17%'
                },
                legend: {
                    right: '4%',
                    itemWidth: 8,
                    itemHeight: 8,
                    icon: 'rect',
                    textStyle: {
                        color: '#a0abc0'
                    },
                    selectedMode: false,
                    data: function (){                                  // 对数据进行处理，来展示 legend
                        if(this.legendData.length !== 0){
                            let res = [];
                            this.legendData.map(item => {
                                res.push(item.name)
                            });
                            return res;
                        }else {
                            return [];
                        }
                    }.call(this),
                },
                xAxis: [{
                    type: 'category',
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            // color: "rgba(255, 255, 255, 0.1)"
                            color: '#223c56'
                        }
                    },
                    axisLabel: {
                        fontSize: 11,
                        color: '#b8d1d2'
                    },
                    data: this.xName
                }],
                yAxis: [],
                series: [{
                    name: this.legendData.length !== 0 ? this.legendData[0].name : '',
                    type: 'bar',
                    barWidth: 10,
                    data: this.firstList
                }, {
                    name: this.legendData.length !== 0 ? this.legendData[1].name : '',
                    type: 'bar',
                    barWidth: 10,
                    data: this.secondList
                }]
            };

            if(this.doubleY){
                option.grid = {
                    left: '14%',
                    top: '10%',
                    right: '12%',
                    bottom: '10%'
                };
                option.yAxis = [{
                    type: 'value',
                    min: 0,
                    max:  Math.ceil((Math.max.apply(Math, [...this.firstList].map((val) => {return val})))/100)*100,
                    interval: (Math.ceil((Math.max.apply(Math, [...this.firstList].map((val) => {return val})))/100)*100)/5,
                    splitNumber: 5,
                    position: 'left',
                    axisLabel: {
                        fontSize: 11,
                        color: '#b8d1d2'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            // color: "rgba(255, 255, 255, 0.1)"
                            color: '#223c56'
                        }
                    }
                }, {
                    type: 'value',
                    min: 0,
                    max:  Math.ceil((Math.max.apply(Math, [...this.secondList].map((val) => {return val})))/100)*100,
                    interval: (Math.ceil((Math.max.apply(Math, [...this.secondList].map((val) => {return val})))/100)*100)/5,
                    splitNumber: 5,
                    position: 'right',
                    axisLabel: {
                        fontSize: 11,
                        color: '#b8d1d2'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            // color: "rgba(255, 255, 255, 0.1)"
                            color: '#223c56'
                        }
                    }
                }];
                option.series[1].yAxisIndex = 1;
            }else {
                option.yAxis = [{
                    type: 'value',
                    axisLabel: {
                        fontSize: 11,
                        color: '#b8d1d2'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            // color: "rgba(255, 255, 255, 0.1)"
                            color: '#223c56'
                        }
                    }
                }];
                option.series[1].yAxisIndex = 0;
            }
            this.myChart.setOption(option);
        }
    },
    watch: {
        'list': {
            immediate: true,
            handler(value){
                if(value.length != 0){
                    this.firstList = [];
                    this.secondList = [];
                    this.xName = [];
                    value.map(item => {
                        this.firstList.push(item[this.legendData[0].type]);
                        this.secondList.push(item[this.legendData[1].type]);
                        this.xName.push(item.dayTime);
                    });
                    this.$nextTick(function(){
                        this.initData();
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.double-bar-page{
    width:100%;
    height:100%;
    display: flex;
    .charts{
        flex:1;
    }
}
</style>